import { DownloadTab, FeatureTab, MemberUse } from '@components'
import { EEvolveLandingPageTabs } from '@configs'
import { Tabs } from 'antd'
import { useState } from 'react'
import { Text } from 'src/common'
import CEOquotesTab from 'src/components/about-us-page-management/ceo-quote/CEOquotesTab'
import BannerTab from 'src/components/evolve-landing-page-management/banner/BannerTab'
import JoinOurCommunity from 'src/components/evolve-landing-page-management/joinOurCommunity/JoinOurCommunity'
import { LibraryTab } from 'src/components/evolve-landing-page-management/library'
import EvolvePageSeo from 'src/components/evolve-landing-page-management/seoConfig/EvolvePageSeo'
import styled from 'styled-components'

interface IEvolveLandingPageManagementProps {}

const EvolveLandingPageManagement = ({}: IEvolveLandingPageManagementProps) => {
  const [activeTab, setActiveTab] = useState<string>(
    EEvolveLandingPageTabs.BANNER
  )

  const tabItems = [
    {
      label: <Text>{EEvolveLandingPageTabs.BANNER}</Text>,
      key: EEvolveLandingPageTabs.BANNER,
      children: <BannerTab activeTab={activeTab} />,
    },
    {
      label: <Text>{EEvolveLandingPageTabs.MEMBER_USE}</Text>,
      key: EEvolveLandingPageTabs.MEMBER_USE,
      children: <MemberUse activeTab={activeTab} />,
    },
    {
      label: <Text>{EEvolveLandingPageTabs.FEATURES_LOVE}</Text>,
      key: EEvolveLandingPageTabs.FEATURES_LOVE,
      children: <FeatureTab activeTab={activeTab} />,
    },
    {
      label: <Text>{EEvolveLandingPageTabs.DOWNLOAD_LLC}</Text>,
      key: EEvolveLandingPageTabs.DOWNLOAD_LLC,
      children: <DownloadTab activeTab={activeTab} />,
    },
    {
      label: <Text>{EEvolveLandingPageTabs.LIBRARY}</Text>,
      key: EEvolveLandingPageTabs.LIBRARY,
      children: <LibraryTab activeTab={activeTab} />,
    },
    {
      label: <Text>{EEvolveLandingPageTabs.JOIN_OUR}</Text>,
      key: EEvolveLandingPageTabs.JOIN_OUR,
      children: <JoinOurCommunity activeTab={activeTab} />,
    },

    {
      label: <Text>{EEvolveLandingPageTabs.SEO_CONFIG}</Text>,
      key: EEvolveLandingPageTabs.SEO_CONFIG,
      children: <EvolvePageSeo activeTab={activeTab} />,
    },
  ]

  return (
    <AboutUsPageStyled>
      <Tabs
        destroyInactiveTabPane={true}
        defaultActiveKey={EEvolveLandingPageTabs.BANNER}
        type="card"
        size={'small'}
        items={tabItems}
        defaultChecked={true}
        activeKey={activeTab}
        onChange={(e) => {
          setActiveTab(e)
        }}
      />
    </AboutUsPageStyled>
  )
}

export default EvolveLandingPageManagement

const AboutUsPageStyled = styled('div')(() => {
  return {
    '.ant-tabs-nav': {
      marginBottom: 0,
      paddingLeft: '1.25rem',

      '& .ant-tabs-tab': {
        borderRadius: '0.75rem 0.75rem 0 0 !important',

        '&.ant-tabs-tab-active': {
          span: {
            color: '#009BB7',
            fontWeight: '500',
          },
        },
      },
    },
  }
})
